import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMVrdMessagesApi = createApi({
  reducerPath: 'dMVrdMessagesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['VRD Messages'],
  endpoints: (builder) => ({
    getMessages: builder.query({
      query: (params) => ({
        url: `/domains/vrd-messages/`,
        params,
      }),
      providesTags: ['VRD Messages'],
    }),

    createMessage: builder.mutation({
      query: (newMessage) => ({
        url: '/domains/vrd-messages/',
        method: 'POST',
        body: newMessage,
      }),
      invalidatesTags: ['VRD Messages'],
    }),

    getMessageById: builder.query({
      query: (id) => ({
        url: `/domains/vrd-messages/${id}`,
        method: 'GET',
      }),
      providesTags: ['VRD Messages'],
    }),

    updateMessage: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/vrd-messages/${id}/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['VRD Messages'],
    }),

    deleteMessage: builder.mutation({
      query: (id) => ({
        url: `/domains/vrd-messages/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VRD Messages'],
    }),
  }),
});

export const {
  useGetMessagesQuery,
  useLazyGetMessagesQuery,
  useCreateMessageMutation,
  useGetMessageByIdQuery,
  useUpdateMessageMutation,
  useDeleteMessageMutation,
} = dMVrdMessagesApi;
